import { render } from "./NavigationButton.vue?vue&type=template&id=fdee343c&scoped=true"
import script from "./NavigationButton.vue?vue&type=script&lang=js"
export * from "./NavigationButton.vue?vue&type=script&lang=js"

import "./NavigationButton.vue?vue&type=style&index=0&id=fdee343c&lang=postcss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdee343c"]])

export default __exports__